/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
  coursesById: {},
  currentProgram: 1,
  modulesById: {},
};

export const courseSlice = createSlice({
  initialState,
  name: 'courseSlice',
  reducers: {
    reset: () => initialState,
    setCourseById: (state, { payload }) => {
      state.coursesById[payload.id] = payload;
    },
    setCurrentProgram: (state, { payload }) => {
      state.currentProgram = payload;
    },
    setModuleById: (state, { payload }) => {
      state.modulesById[payload.id] = payload;
    },
  },
});

export const courseSlicePersistedReducer = persistReducer(
  {
    key: 'courseSlice',
    storage,
  },
  courseSlice.reducer
);
